import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'view.header.languageLabel',
    defaultMessage: 'Language',
  },
});
